module.exports = __webpack_public_path__ + "static/media/ic-leaf.b3346136.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ic-leaf.svg
// module id = 1955
// module chunks = 0